import { render, staticRenderFns } from "./AdmissionEnquiries.vue?vue&type=template&id=27b538c6"
import script from "./AdmissionEnquiries.vue?vue&type=script&lang=js"
export * from "./AdmissionEnquiries.vue?vue&type=script&lang=js"
import style0 from "./AdmissionEnquiries.vue?vue&type=style&index=0&id=27b538c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports